var _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 11.9843,
    cy: 12.0479,
    r: 11.247
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.0442,0.8009 c3.1057,0,5.6235,5.0355,5.6235,11.247c0,6.2113-2.5178,11.2472-5.6235,11.2472"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.9517,0.8009 c-3.1057,0-5.6235,5.0355-5.6235,11.247c0,6.2113,2.5177,11.2472,5.6235,11.2472"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 11.9843,
    y1: 0.8009,
    x2: 11.9843,
    y2: 23.2951
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 23.222,
    y1: 12.5001,
    x2: 0.7373,
    y2: 12.5001
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 22.2733,
    y1: 7.5002,
    x2: 1.6952,
    y2: 7.5002
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x1: 21.8231,
    y1: 17.5001,
    x2: 2.145,
    y2: 17.5001
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.0137,
    y: 0.0001,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRes);
export default __webpack_public_path__ + "static/media/res.91d476980ca36f18a735716e1e7645f6.svg";
export { ForwardRef as ReactComponent };